module.exports = __webpack_public_path__ + "static/media/basket.09e5587b.svg";